// extracted by mini-css-extract-plugin
export var cls1 = "SilencioSemicorcheaSvg-module--cls-1--rFEpg";